// extracted by mini-css-extract-plugin
export default {"container":"ImageLoader_container__jciE+","flare":"ImageLoader_flare__fwqOV","animation-image-loader":"ImageLoader_animation-image-loader__3VRL7"};